import { render, staticRenderFns } from "./print-grid.html?vue&type=template&id=23484e44&scoped=true&"
import script from "./print-grid.ts?vue&type=script&lang=js&"
export * from "./print-grid.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23484e44",
  null
  
)

export default component.exports